import $ from 'cash-dom';
import EmblaCarousel from 'embla-carousel';
import { setupDotBtns, generateDotBtns, selectDotBtn } from "./embla-dot-helpers";

$(function () {
    if ($('.product-tabs').length != 0) {
        var parent = $('.product-tabs');

        parent.find('.product-head-tab').each(function() {
            var dataID = $(this).data('block-id');

            $(this).on('click', function (e) {
                parent.find('.product-head-tab.active').removeClass('active');
                parent.find('.product-content-tab.active').removeClass('active');
                parent.find('.product-head-tab[data-block-id="' + dataID + '"').addClass('active')
                parent.find('.product-content-tab[data-block-id="' + dataID + '"').addClass('active')
            })
        })
    }

    if($('.product-app-info').length != 0) {
        const sliderParent = document.querySelector('.product-app-wrapper');
        const sliderNode =  sliderParent.querySelector('.product-app-media-embla');
        const options = {
            loop: false,
            align: 'center',
            containerSelector: '.product-app-media-inner',
            slidesToScroll: 1
        };

        const slider = EmblaCarousel(sliderNode, options)
        const dotsFeatured = sliderParent.querySelector('.embla__dots');
        let dotsFeaturedArr = generateDotBtns(dotsFeatured, slider);
        let setSelectedDotBtn = selectDotBtn(dotsFeaturedArr, slider);

        setupDotBtns(dotsFeaturedArr, slider);
        slider.on('select', setSelectedDotBtn);
        slider.on('init', setSelectedDotBtn);

        $('.product-app-item').each(function () {
            $(this).on('click', function (e) {
                var index = $(this).data('index');
                $('.product-app-item.is-active').removeClass('is-active');
                $(this).addClass('is-active');
                $('.product-app-media').find('.embla__dots').children().eq(index).trigger('click');
            })
        })
    }
})